/* THIS FILE IS GENERATED BY AssistantContextTypeScriptGenerator. */
export type AccessExpansionAssistantCommand = { action: string }
export type AccessGroupingAssistantCommand = { grouping: string }
export type AccountMenuAssistantCommand = { open: boolean }
export type FilterAssistantCommand = { surface: string; value: string }
export type FocusMainAssistantCommand = Record<string, never>
export type HierarchyNodeAssistantCommand = { entityId: string; expanded: boolean }
export type HighContrastAssistantCommand = { enabled: boolean }
export type InvitationModeAssistantCommand = { advanced: boolean }
export type NavigateAssistantCommand = { page: string; entityId: string | null; targetId: string | null }
export type NotificationsAssistantCommand = { open: boolean }
export type PrinterPolicyGroupAssistantCommand = { entityId: string; valueType: string; expanded: boolean }
export type PrinterPolicySelectionAssistantCommand = { entityId: string; valueType: string; policyId: string; expanded: boolean }
export type SettingHistoryAssistantCommand = { activityId: string; expanded: boolean }
export type SidebarAssistantCommand = { collapsed: boolean }
export type SignOutAssistantCommand = Record<string, never>
export type SwitchEntityAssistantCommand = { entityId: string; name: string }
export type ThemeAssistantCommand = { theme: string }

export type AssistantBrowserCommand =
  | { type: "access_expansion"; payload: AccessExpansionAssistantCommand }
  | { type: "access_grouping"; payload: AccessGroupingAssistantCommand }
  | { type: "account_menu"; payload: AccountMenuAssistantCommand }
  | { type: "filter"; payload: FilterAssistantCommand }
  | { type: "focus_main"; payload: FocusMainAssistantCommand }
  | { type: "hierarchy_node"; payload: HierarchyNodeAssistantCommand }
  | { type: "high_contrast"; payload: HighContrastAssistantCommand }
  | { type: "invitation_mode"; payload: InvitationModeAssistantCommand }
  | { type: "navigate"; payload: NavigateAssistantCommand }
  | { type: "notifications"; payload: NotificationsAssistantCommand }
  | { type: "printer_policy_group"; payload: PrinterPolicyGroupAssistantCommand }
  | { type: "printer_policy_selection"; payload: PrinterPolicySelectionAssistantCommand }
  | { type: "setting_history"; payload: SettingHistoryAssistantCommand }
  | { type: "sidebar"; payload: SidebarAssistantCommand }
  | { type: "sign_out"; payload: SignOutAssistantCommand }
  | { type: "switch_entity"; payload: SwitchEntityAssistantCommand }
  | { type: "theme"; payload: ThemeAssistantCommand }

export type AssistantBrowserCommandType = AssistantBrowserCommand['type']
export type AssistantBrowserCommandPayload<T extends AssistantBrowserCommandType> =
  Extract<AssistantBrowserCommand, { type: T }>['payload']

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function hasOnlyKeys(value: Record<string, unknown>, keys: readonly string[]) {
  const actual = Object.keys(value)
  return actual.length === keys.length && actual.every((key) => keys.includes(key))
}

function isUuid(value: unknown): value is string {
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
}

function decodeAccessExpansionAssistantCommand(value: unknown): AccessExpansionAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["action"])) return null
  if (!(typeof value.action === 'string')) return null
  return { action: value.action }
}

function decodeAccessGroupingAssistantCommand(value: unknown): AccessGroupingAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["grouping"])) return null
  if (!(typeof value.grouping === 'string')) return null
  return { grouping: value.grouping }
}

function decodeAccountMenuAssistantCommand(value: unknown): AccountMenuAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["open"])) return null
  if (!(typeof value.open === 'boolean')) return null
  return { open: value.open }
}

function decodeFilterAssistantCommand(value: unknown): FilterAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["surface", "value"])) return null
  if (!(typeof value.surface === 'string')) return null
  if (!(typeof value.value === 'string')) return null
  return { surface: value.surface, value: value.value }
}

function decodeFocusMainAssistantCommand(value: unknown): FocusMainAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, [])) return null
  return { }
}

function decodeHierarchyNodeAssistantCommand(value: unknown): HierarchyNodeAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["entityId", "expanded"])) return null
  if (!(isUuid(value.entityId))) return null
  if (!(typeof value.expanded === 'boolean')) return null
  return { entityId: value.entityId, expanded: value.expanded }
}

function decodeHighContrastAssistantCommand(value: unknown): HighContrastAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["enabled"])) return null
  if (!(typeof value.enabled === 'boolean')) return null
  return { enabled: value.enabled }
}

function decodeInvitationModeAssistantCommand(value: unknown): InvitationModeAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["advanced"])) return null
  if (!(typeof value.advanced === 'boolean')) return null
  return { advanced: value.advanced }
}

function decodeNavigateAssistantCommand(value: unknown): NavigateAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["page", "entityId", "targetId"])) return null
  if (!(typeof value.page === 'string')) return null
  if (!(value.entityId === null || isUuid(value.entityId))) return null
  if (!(value.targetId === null || isUuid(value.targetId))) return null
  return { page: value.page, entityId: value.entityId, targetId: value.targetId }
}

function decodeNotificationsAssistantCommand(value: unknown): NotificationsAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["open"])) return null
  if (!(typeof value.open === 'boolean')) return null
  return { open: value.open }
}

function decodePrinterPolicyGroupAssistantCommand(value: unknown): PrinterPolicyGroupAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["entityId", "valueType", "expanded"])) return null
  if (!(isUuid(value.entityId))) return null
  if (!(typeof value.valueType === 'string')) return null
  if (!(typeof value.expanded === 'boolean')) return null
  return { entityId: value.entityId, valueType: value.valueType, expanded: value.expanded }
}

function decodePrinterPolicySelectionAssistantCommand(value: unknown): PrinterPolicySelectionAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["entityId", "valueType", "policyId", "expanded"])) return null
  if (!(isUuid(value.entityId))) return null
  if (!(typeof value.valueType === 'string')) return null
  if (!(isUuid(value.policyId))) return null
  if (!(typeof value.expanded === 'boolean')) return null
  return { entityId: value.entityId, valueType: value.valueType, policyId: value.policyId, expanded: value.expanded }
}

function decodeSettingHistoryAssistantCommand(value: unknown): SettingHistoryAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["activityId", "expanded"])) return null
  if (!(isUuid(value.activityId))) return null
  if (!(typeof value.expanded === 'boolean')) return null
  return { activityId: value.activityId, expanded: value.expanded }
}

function decodeSidebarAssistantCommand(value: unknown): SidebarAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["collapsed"])) return null
  if (!(typeof value.collapsed === 'boolean')) return null
  return { collapsed: value.collapsed }
}

function decodeSignOutAssistantCommand(value: unknown): SignOutAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, [])) return null
  return { }
}

function decodeSwitchEntityAssistantCommand(value: unknown): SwitchEntityAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["entityId", "name"])) return null
  if (!(isUuid(value.entityId))) return null
  if (!(typeof value.name === 'string')) return null
  return { entityId: value.entityId, name: value.name }
}

function decodeThemeAssistantCommand(value: unknown): ThemeAssistantCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ["theme"])) return null
  if (!(typeof value.theme === 'string')) return null
  return { theme: value.theme }
}

export const assistantBrowserCommands = {
  accessExpansion: { type: "access_expansion", decode: decodeAccessExpansionAssistantCommand },
  accessGrouping: { type: "access_grouping", decode: decodeAccessGroupingAssistantCommand },
  accountMenu: { type: "account_menu", decode: decodeAccountMenuAssistantCommand },
  filter: { type: "filter", decode: decodeFilterAssistantCommand },
  focusMain: { type: "focus_main", decode: decodeFocusMainAssistantCommand },
  hierarchyNode: { type: "hierarchy_node", decode: decodeHierarchyNodeAssistantCommand },
  highContrast: { type: "high_contrast", decode: decodeHighContrastAssistantCommand },
  invitationMode: { type: "invitation_mode", decode: decodeInvitationModeAssistantCommand },
  navigate: { type: "navigate", decode: decodeNavigateAssistantCommand },
  notifications: { type: "notifications", decode: decodeNotificationsAssistantCommand },
  printerPolicyGroup: { type: "printer_policy_group", decode: decodePrinterPolicyGroupAssistantCommand },
  printerPolicySelection: { type: "printer_policy_selection", decode: decodePrinterPolicySelectionAssistantCommand },
  settingHistory: { type: "setting_history", decode: decodeSettingHistoryAssistantCommand },
  sidebar: { type: "sidebar", decode: decodeSidebarAssistantCommand },
  signOut: { type: "sign_out", decode: decodeSignOutAssistantCommand },
  switchEntity: { type: "switch_entity", decode: decodeSwitchEntityAssistantCommand },
  theme: { type: "theme", decode: decodeThemeAssistantCommand },
} as const

export function decodeAssistantBrowserCommand(value: unknown): AssistantBrowserCommand | null {
  if (!isRecord(value) || !hasOnlyKeys(value, ['type', 'payload']) || typeof value.type !== 'string') return null
  switch (value.type) {
    case "access_expansion": {
      const payload = decodeAccessExpansionAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "access_grouping": {
      const payload = decodeAccessGroupingAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "account_menu": {
      const payload = decodeAccountMenuAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "filter": {
      const payload = decodeFilterAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "focus_main": {
      const payload = decodeFocusMainAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "hierarchy_node": {
      const payload = decodeHierarchyNodeAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "high_contrast": {
      const payload = decodeHighContrastAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "invitation_mode": {
      const payload = decodeInvitationModeAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "navigate": {
      const payload = decodeNavigateAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "notifications": {
      const payload = decodeNotificationsAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "printer_policy_group": {
      const payload = decodePrinterPolicyGroupAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "printer_policy_selection": {
      const payload = decodePrinterPolicySelectionAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "setting_history": {
      const payload = decodeSettingHistoryAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "sidebar": {
      const payload = decodeSidebarAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "sign_out": {
      const payload = decodeSignOutAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "switch_entity": {
      const payload = decodeSwitchEntityAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    case "theme": {
      const payload = decodeThemeAssistantCommand(value.payload)
      return payload === null ? null : { type: value.type, payload }
    }
    default:
      return null
  }
}
